'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ecommerceManagerFactory = undefined;

var _constants = require('./constants');

var addEcommerceInformation = function addEcommerceInformation(products) {
  return products.map(function (product) {
    return Object.assign({
      brand: _constants.ECOMMERCE_BRAND
    }, product);
  });
};

var ecommerceManagerFactory = exports.ecommerceManagerFactory = function ecommerceManagerFactory(send) {
  var currencyCode = void 0;
  var sendEcommerceEvent = function sendEcommerceEvent(action, payload, _ref) {
    var sendInHouseAnalytics = _ref.sendInHouseAnalytics;

    send({
      ecommerceAction: action,
      ecommerce: Object.assign({
        currencyCode: currencyCode
      }, payload),
      sendInHouseAnalytics: sendInHouseAnalytics
    });
  };

  return {
    setCurrencyCode: function setCurrencyCode(code) {
      currencyCode = code;
    },
    sendProductImpression: function sendProductImpression(products) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      sendEcommerceEvent(_constants.ECOMMERCE_ACTIONS.view_item_list, {
        products: addEcommerceInformation(products)
      }, { sendInHouseAnalytics: options.sendInHouseAnalytics });
    },
    sendSelectedProduct: function sendSelectedProduct(product, options) {
      sendEcommerceEvent(_constants.ECOMMERCE_ACTIONS.select_item, {
        actionField: options,
        products: addEcommerceInformation([product])
      }, { sendInHouseAnalytics: options.sendInHouseAnalytics });
    },
    sendProductDetail: function sendProductDetail(product) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      sendEcommerceEvent(_constants.ECOMMERCE_ACTIONS.view_item, {
        products: addEcommerceInformation([product])
      }, { sendInHouseAnalytics: options.sendInHouseAnalytics });
    },
    sendAddProductToCart: function sendAddProductToCart(product) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      sendEcommerceEvent(_constants.ECOMMERCE_ACTIONS.add_to_cart, {
        products: addEcommerceInformation([product])
      }, { sendInHouseAnalytics: options.sendInHouseAnalytics });
    },
    sendCheckoutStep: function sendCheckoutStep(product, options) {
      sendEcommerceEvent(_constants.ECOMMERCE_ACTIONS_CHECKOUT[options.step], {
        actionField: options,
        products: addEcommerceInformation([product])
      }, { sendInHouseAnalytics: options.sendInHouseAnalytics });
    },
    sendCheckoutPaymentType: function sendCheckoutPaymentType(options) {
      sendEcommerceEvent(_constants.ECOMMERCE_ACTIONS.checkout_option, {
        actionField: options
      }, { sendInHouseAnalytics: options.sendInHouseAnalytics });
    }
  };
};

exports.default = {
  ecommerceManagerFactory: ecommerceManagerFactory
};
//# sourceMappingURL=ecommerceManagerFactoryGA4.js.map